'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Paper, Skeleton } from '@mui/material';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { getCookie, setCookie } from '@/api/utils/index';
import { currencies, mainCurrencies } from '@/contexts/currency/currencies';
import { useCurrency } from '@/contexts/CurrencyContext';
const CurrencyElement = ({ code, title, handler }) => (_jsxs(Box, { sx: {
        'display': 'flex',
        'gap': 1,
        'alignItems': 'center',
        'cursor': 'pointer',
        '&:hover': {
            color: 'rgb(176,40,40)',
        },
    }, onClick: () => handler(code), children: [_jsx(Typography, { fontSize: 16, fontWeight: 600, children: code }), _jsx(Typography, { fontSize: 16, children: title })] }, code));
export default function CurrencySelector({ title }) {
    var _a;
    const { changeCurrency, selectedCurrency } = useCurrency();
    const { formatMessage } = useIntl();
    const [anchorEl, setAnchorEl] = useState(null);
    useEffect(() => {
        if (selectedCurrency && selectedCurrency !== getCookie('currency_code')) {
            setCookie('currency_code', selectedCurrency);
        }
    }, [selectedCurrency]);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const currencyHandler = (code) => {
        if (code) {
            changeCurrency(code);
            handleClose();
        }
        handleClose();
    };
    const mainCurrenciesRows = useMemo(() => Math.ceil(Object.keys(mainCurrencies).length / 4), []);
    const currenciesRows = useMemo(() => Math.ceil(Object.keys(currencies).length / 4), []);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (_jsxs(Fragment, { children: [_jsx(Typography, { children: title }), selectedCurrency
                ? (_jsx(Typography, { onClick: handleClick, sx: {
                        fontSize: 'inherit',
                        fontWeight: 600,
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        userSelect: 'none',
                    }, children: selectedCurrency }))
                : _jsx(Skeleton, { width: 50, height: 36 }), _jsx(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, children: _jsxs(Paper, { sx: {
                        padding: '24px',
                        width: { xs: '400px', md: 'auto' },
                    }, children: [_jsx(Box, { sx: {
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
                                gridTemplateRows: { md: `repeat(${mainCurrenciesRows}, auto)` },
                                gridAutoFlow: { xs: 'row', md: 'column' },
                                gap: 2,
                                borderBottom: '1px solid #E5E7EB',
                                paddingBottom: '16px',
                            }, children: (_a = Object.keys(mainCurrencies)) === null || _a === void 0 ? void 0 : _a.map((code, index) => (_jsx(CurrencyElement, { code: code, title: formatMessage(mainCurrencies === null || mainCurrencies === void 0 ? void 0 : mainCurrencies[code]), handler: currencyHandler }, `${code}_${index}`))) }), _jsx(Box, { sx: {
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
                                gridTemplateRows: { md: `repeat(${currenciesRows}, auto)` },
                                gridAutoFlow: { xs: 'row', md: 'column' },
                                gap: 2,
                            }, children: Object.keys(currencies).map((code, index) => (_jsx(CurrencyElement, { code: code, title: formatMessage(currencies === null || currencies === void 0 ? void 0 : currencies[code]), handler: currencyHandler }, `${code}_${index}`))) })] }) })] }));
}
